export default {
  basicData: {
    position: {
      lat: 36.00000,
      lng: 138.00000
    },
    zoom: 5,
    mapType: 'satellite'
  },
  mapData: []
}
